/**
 * @file: NavParams.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { ProductDetailPage } from '@euler/app/flows/products/ProductDetailPage';
import { ScreenToParams } from '@euler/functions/spreadScreens';
import { AddProductPage } from './AddProductPage';
import { ProductManifestPage } from './ProductManifestPage';

export const ProductScreens = {
  _productManifest: ProductManifestPage,
  _addProduct: AddProductPage,
  _productDetail: ProductDetailPage,
};

export type ProductNavParams = ScreenToParams<typeof ProductScreens>;
